import { render, staticRenderFns } from "./newPeople.vue?vue&type=template&id=0d767570&scoped=true"
import script from "./newPeople.vue?vue&type=script&lang=js"
export * from "./newPeople.vue?vue&type=script&lang=js"
import style0 from "./newPeople.vue?vue&type=style&index=0&id=0d767570&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d767570",
  null
  
)

export default component.exports